import { environment } from '../../environments/environment';

// TEMPORARY local-development override for MCD Dashboard access.
//
// `mcdDashboardAccessOverride` is true only in the git-ignored
// src/environments/environment.local.ts, which is used exclusively by the
// "local" Angular configuration (see angular.json / package.json). Staging,
// dev and production environment files keep the flag false, so those builds
// cannot turn the bypass on.
//
// Remove this file and its usages (StorageService.isMcdEmployee, the "local"
// build/serve configuration and environment.local*.ts) once the backend
// UserGroup/PartnerMembership access check is available.
export function isMcdDashboardAccessOverrideEnabled(): boolean {
  return environment.mcdDashboardAccessOverride === true;
}

export function resolveMcdDashboardAccess(
  isMcdEmployee: boolean,
  overrideEnabled: boolean = isMcdDashboardAccessOverrideEnabled()
): boolean {
  return overrideEnabled === true || isMcdEmployee === true;
}
